import { DESKTOP_SPACING } from "@/theme";
import styled from "styled-components";

export const StyledFilterAction = styled.div`
  align-items: end;
  display: flex;
  justify-content: end;
  margin-bottom: ${DESKTOP_SPACING.XXXL}px;
  width: 100%;
`;